import * as uiActions from '../actions/ui';

const initialState = {
    loading: false,
    isFormSubmittng: false
}

export default (state = initialState, action) => {
    switch (action.type) {
        case (uiActions.SET_LOADING_ON):
        case (uiActions.SET_LOADING_OFF):
            return { ...state, loading: action.payload };
        case (uiActions.SET_FORMSUBMITTING_ON):
        case (uiActions.SET_FORMSUBMITTING_OFF):
            return { ...state, isFormSubmittng: action.payload };
        default:
            return state;
    }
}